export enum ProxyRuleDeploymentResourceType {
    Function = 'function',
    Site = 'site',
}